import React from 'react';
import { Alert, Avatar, Card, CardHeader, Stack, Typography } from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import NotFound from './NotFound';

export default function Products({ type, products, categories, assignmentType }) {
  if (assignmentType === 'ALL_PRODUCT') {
    return <Alert severity="success">این بن شامل همه محصولات فروشگاه می باشد.</Alert>;
  }

  if (assignmentType === 'SELECTED_PRODUCT') {
    return (
      <Stack rowGap={0.5}>
        <Alert severity="error">این بن تنها شامل محصولات زیر می باشد.</Alert>
        {products.map((item, i) => (
          <ProductCard key={i} {...item} />
        ))}
      </Stack>
    );
  }

  if (categories && categories.length > 0) {
    return (
      <Stack rowGap={0.5}>
        <Alert severity="warning">این بن تنها شامل دسته محصولات زیر می باشد.</Alert>
        {categories.map((item, i) => (
          <CategoryCard key={i} category={item} />
        ))}
      </Stack>
    );
  }

  return <NotFound />;

  // return (
  //   <Stack rowGap={0.5}>
  //     {assignmentType === 'ALL_PRODUCT' && }
  //     {assignmentType === 'SELECTED_PRODUCT' && }
  //     {categories && }
  //     {products.map((item, i) => (
  //       <ProductCard key={i} {...item} />
  //     ))}
  //   </Stack>
  // );
}

{
  /* function Alert({ title }) {
  return (
    <Card sx={{ bgcolor: 'warning.lighter', mb: 1 }}>
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'warning.lighter' }}>
            <WarningRoundedIcon color="warning" fontSize="small" />
          </Avatar>
        }
        subheader={<Typography variant="caption">{title}</Typography>}
      />
    </Card>
  );
} */
}

function ProductCard({ id, product_info }) {
  const { title, brand, media } = product_info;
  const img = media[0]?.full_url || '/assets/images/picture.png';
  return (
    <Card sx={{ width: '100%' }}>
      <CardHeader
        title={
          <Typography fontSize={14} variant="subtitle1">
            {`${title} ${brand?.title || ''}`}
          </Typography>
        }
        avatar={<Avatar sx={{ bgcolor: 'action.hover' }} src={img} />}
        // action={
        //   <IconButton color="error" disabled={loading} size="small" onClick={() => onDelete(id)}>
        //     <DeleteOutlineRounded fontSize="small" />
        //   </IconButton>
        // }
      />
    </Card>
  );
}

function CategoryCard({ category }) {
  const media = category.media[0]?.full_url;
  const img = media || '/assets/images/picture.png';
  return (
    <Card sx={{ width: '100%', bgcolor: 'warning.lighter' }}>
      <CardHeader
        sx={{ p: 1 }}
        avatar={<Avatar src={img} />}
        subheader={
          <Typography variant="subtitle1" component="span" color="primary.main">
            {category.title}
          </Typography>
        }
      />
    </Card>
  );
}
